export const environment = {
  env: "uat",
  production: false,
  backendURL: "https://mb-uat.fishyhub.com",
  // Public storage CDN for message photos/videos (chat/... keys).
  chatMediaCdnURL: "https://uat-cdn.fishyhub.com",
  standard_width: 768,
  firebaseConfig: {
    apiKey: "AIzaSyD1rslJse0a4DPlIIwCmHR66IY-xsnFWL0",
    authDomain: "fishyhub-uat.firebaseapp.com",
    databaseURL: "https://fishyhub-uat-default-rtdb.firebaseio.com",
    projectId: "fishyhub-uat",
    storageBucket: "fishyhub-uat.appspot.com",
    messagingSenderId: "154662828420",
    appId: "1:154662828420:web:fc1c4d146257a01caa45d1",
    measurementId: "G-LQM20BNT2S",
  },
  // See environment.ts for why this is a second, separately-named Firebase app.
  // Mirrors web-frontend's .env.uat NEXT_PUBLIC_FIREBASE_* values.
  webFirebaseConfig: {
    apiKey: "AIzaSyBiExG7NcYJyfEaZAVKtmz0nlmteheYppg",
    authDomain: "fishyhub-uat-aca15.firebaseapp.com",
    projectId: "fishyhub-uat-aca15",
    storageBucket: "fishyhub-uat-aca15.appspot.com",
    messagingSenderId: "129642831220",
    appId: "1:129642831220:web:11782596b0d526538aa021",
    measurementId: "G-DY5B7BHPMR",
  },
};
